export default __webpack_public_path__ + "static/media/icon-coin-bat.63418259.svg";